import { render } from "./call-history-modal.vue?vue&type=template&id=8cbf8d94"
import script from "./call-history-modal.vue?vue&type=script&lang=js"
export * from "./call-history-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__